export const ADD_FILTER = 'ADD_FILTER';
export const ADD_MULTI_SELECT = 'ADD_MULTI_SELECT';
export const TOGGLE_SLIDE_LEAVE = 'TOGGLE_SLIDE_LEAVE';
export const TOGGLE_SLIDE_STATUS = 'TOGGLE_SLIDE_STATUS';
export const EXPLORE_OPTION = 'EXPLORE_OPTION';

export const CareerPlanActionTypes = {
  DATA_LOAD: 'data_load',
  POSITION_UPDATE: 'position_update',
  POSITION_CLEAR: 'position_clear',
  POSITION_REMOVE: 'position_remove',
};
